<template>
  <div class="div" v-loading="loading" style="padding: 0px">
    <!-- <div class="title">备件电价格表</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建电价格表</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        clearable
        v-model="searchData.Keyword"
        placeholder="请输入价格表名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>

      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button type="primary" @click="openPrice" style="margin-left: 10px"
        >获取系统价格表</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 50px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="价格表名称"
          align="center"
          prop="PriceName"
          sortable
        >
        </el-table-column>

        <el-table-column
          label="是否峰谷价"
          align="center"
          prop="IsLadderPrice"
          sortable
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsLadderPrice">是</el-tag>
            <el-tag type="success" v-else>否</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="非峰谷价格"
          align="center"
          prop="Price"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="按月/日导入数据"
          align="center"
          prop="DataType"
          sortable
        >
          <template slot-scope="scope">
            <SelectDicName
              ref="SelectDicName"
              :typeValue="scope.row.DataType"
              code="DataType"
            ></SelectDicName>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
    <ProceDialog
      ref="ProceDialog"
      type="radio"
      priceType="电"
      @success="handleSearch"
    ></ProceDialog>
  </div>
</template>
<script>
import EditForm from './EditForm.vue'
import moment from 'moment'
import SelectDicName from '@/components/DicValue/SelectDicName.vue'
import ProceDialog from '@/components/BasicsEnergyPrice/ProceDialog.vue'

export default {
  data() {
    return {
      moment,
      searchData: {
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, SelectDicName, ProceDialog },
  methods: {
    openPrice() {
      this.$refs.ProceDialog.openDialog()
    },
    selectable(row) {
      return row.Status == 0
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base/Base_ElectricityPrice/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            Condition: 'PriceName',
            Keyword: this.searchData.Keyword,
          },
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建电价格表')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该电价格表单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base/Base_ElectricityPrice/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row, num) {
      if (num == 1) {
        this.$refs.EditForm.openForm('电价格表详情', row, true)
        return
      }
      if (num == 2) {
        this.$refs.EditForm.openForm('审核电价格表详情', row, true)
        return
      }
      this.$refs.EditForm.openForm('编辑电价格表', row, false)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
